
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFullStoriesDetails } from '../../../../store/reducers/getStoryDetailsSlice';
import { useParams } from 'react-router-dom';
import Footer from '../../Footer';
import Spinner from "react-bootstrap/Spinner";
import Head from "../../Head";
import "./ReadFullArticle.css";

const ReadFullArticle = () => {
  const location = useLocation();
  const { storyId } = useParams();
  const dispatch = useDispatch();
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Access the Redux state
  const { story, loading } = useSelector((state) => state?.fetchFullStories);

  useEffect(() => {
    if (storyId) {
      dispatch(fetchFullStoriesDetails(storyId));
    }
  }, [dispatch, storyId]);

  // Hide spinner after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(false);
    }, 1000); // 1000 milliseconds = 1 seconds

    return () => clearTimeout(timer);
  }, []);

  // If loading is true, show spinner
  if (loading || showSpinner) {
    return (
      <div className="spinner-container-read">
        <Spinner animation="border" variant="dark" size="xl" />
      </div>
    );
  }

  // Check if the story is available
  if (!story) {
    return <p className='no-article-found'>No article found.</p>;
  }

  // Function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  return (
    <>
      <div className="top-head-section-new"></div>
      <div className="main-artical-section">
        <Head />
        <div className="container p-0">
          <div className="row">
            <div className="news-full-detail blog-postfull-page">
              <div className="readFull-article-headerInner">
                <h2>{story?.data?.heading}</h2>
                <p className="date-time">{formatDate(story?.data?.createdAt)}</p>
              </div>

              <div className="news-banner">
                {story?.data?.from ? (
                  <img src={`${process.env.REACT_APP_API_ENDPOINT_URL}/${story?.data?.image}`} alt={story?.data?.title} />
                ) : null}
              </div>
              <div className="readFull-article-content">
                <div className="readFull-article-inner">

                  {story.data.content_html ? (
                    <div className="description-content" dangerouslySetInnerHTML={{ __html: story?.data?.content_html }}
                    />
                  ) : <p className="description-content">{story?.data?.description}</p>}
                  <p className="description-content">
                    Source: <a href={story.data.source ? story.data.source : story.data.from} target="_blank" rel="noopener noreferrer">{story.data.source ? story.data.source : story.data.from}</a>
                  </p></div></div>

            </div>
          </div>
        </div>
      </div>
      <div className="about-footer">
        <Footer />
      </div>
    </>
  );
};

export default ReadFullArticle;